import Auth from "./../services/Auth";
import { getCookie } from "./Cookie";
import { getUrlParam } from "./Url";

const RF = {
  requireAuth(to, from, next) {
    if (!Auth.loggedIn()) {
      let queryStringOriginAl = "";
      if (getUrlParam("origin") == "al" || getCookie("origin") == "al") {
        queryStringOriginAl = "&origin=al";
      }

      let returnTo =
        "&path=" +
        btoa(process.env.VUE_APP_ACCOUNT + "?ref=v2" + queryStringOriginAl);

      window.location.href =
        process.env.VUE_APP_SITE +
        "/minha-conta/?ref=v2" +
        returnTo +
        queryStringOriginAl;
      // next({
      //   path: "/login",
      //   query: { redirect: to.fullPath },
      // });
    } else {
      next();
    }
  },
  logout(to, from, next) {
    let queryStringOriginAl = "";
    if (getUrlParam("origin") == "al" || getCookie("origin") == "al") {
      queryStringOriginAl = "&origin=al";
    }

    Auth.logout();
    const ref = sessionStorage.getItem("ref");

    window.location.href = process.env.VUE_APP_SITE + "/logout?ref=" + ref + queryStringOriginAl;

    next();
    // next('/login')
  },
};

export default RF;
